const parseFloorplans = (data, assetsData) => {
  const list = assetsData.map((floorplan) => {
    // const floorplanAssets = assetsData.find(plan =>
    //   plan.name === floorplan.name
    // );

    let beds = 0;
    if (floorplan.type.indexOf('one') > -1) {
      beds = 1;
    } else if (floorplan.type.indexOf('two') > -1) {
      beds = 2;
    } else if (floorplan.type.indexOf('three') > -1) {
      beds = 3;
    }

    return {
      id: floorplan.id.toString(),
      favourited: false,
      name: floorplan.name,
      interior: floorplan.conditions[0].interior,
      exterior: floorplan.conditions[0].exterior,
      beds: beds,
      dens: floorplan.type.indexOf('Den') > -1 ? 1 : 0,
      baths: floorplan.filter,
      exposure: floorplan.dir.split(''),
      suites: floorplan.conditions[0].suites.map(unit => ({
        exposure: unit.dir,
        id: unit.id,
        floor: unit.floor,
        status: unit.status,
        name: unit.suite,
        price: 500000
      })),
      assets: {
        thumbnail: floorplan.conditions[0].images.find(img => img.type === 'thumb'),
        floorplan: floorplan.conditions[0].images.find(img => img.type === 'fp'),
        keyplan: floorplan.conditions[0].images.find(img => img.type === 'kp'),
        pdf: floorplan.conditions[0].images.find(img => img.type === 'pdf')
      },
      viewType: floorplan.conditions[0].condition_name
    };
  });

  list.sort((a, b) => a.interior - b.interior);
  return list;
};

/* eslint-disable */
const toHSL = (hex) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);

    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min){
        h = s = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    s = s*100;
    s = Math.round(s);
    l = l*100;
    l = Math.round(l);
    h = Math.round(360*h);

    var colorInHSL = 'hsl(' + h + ', ' + s + '%, ' + l + '%)';

    return {
      h: h,
      s: s + '%',
      l: l + '%'
    };
};
/* eslint-enable */

const parseSettings = data => ({
  hasScaleModel: data.find(el => el.key === 'HAS_SCALE_MODEL').value === 'true',
  hasAvailability: data.find(el => el.key === 'HAS_AVAILABILITY').value === 'true',
  assetsUrl: data.find(el => el.key === 'BASE_ASSET_URL').value,
  showPrices: data.find(el => el.key === 'SHOW_PRICES').value === 'true',
  theme: {
    colours: data.filter(el => el.type === 'colour').map((el) => {
      const hsl = toHSL(el.value);
      return {
        name: el.key.replace('_COLOUR', '').replace('_', '-').toLowerCase(),
        h: hsl.h,
        s: hsl.s,
        l: hsl.l
      };
    })
  }
});

const parseTypeSlug = (slug) => {
  switch (slug) {
    case 'studio': return 'Studio';
    case 'one': return '1 Bed';
    case 'oneDen': return '1 Bed + Den';
    case 'two': return '2 Beds';
    case 'twoDen': return '2 Beds + Den';
    case 'three': return '3 Beds';
    case 'threeDen': return '3 Beds + Den';
    default: return slug;
  }
};

const typeSlugToBeds = (typeSlug) => {
  const beds = typeSlug.replace('Den', '');
  switch (beds) {
    case 'studio': return 0;
    case 'one': return 1;
    case 'two': return 2;
    case 'three': return 3;
    default: return typeSlug;
  }
};

const typeSlugToDens = (typeSlug) => {
  const den = typeSlug.substr(typeSlug.length - 3);
  switch (den) {
    case 'Den': return 1;
    default: return 0;
  }
};

const bedsToTypeSlug = (beds) => {
  switch (beds) {
    case 0: return 'studio';
    case 1: return 'one';
    case 2: return 'two';
    case 3: return 'three';
    default: return '';
  }
};

const densToTypeSlug = (den) => {
  switch (den) {
    case 1: return 'Den';
    default: return '';
  }
};

export default {
  parseFloorplans,
  parseSettings,
  parseTypeSlug,
  typeSlugToBeds,
  typeSlugToDens,
  bedsToTypeSlug,
  densToTypeSlug
};



// WEBPACK FOOTER //
// ./src/services/parsers/adhocParser.js